import { render } from "./internazionale.vue?vue&type=template&id=36bf0627&bindings={\"navigate\":\"props\"}"
import script from "./internazionale.vue?vue&type=script&lang=js"
export * from "./internazionale.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./internazionale.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script